import { render } from "./cdrBatchPremium.vue?vue&type=template&id=17ef5e97&scoped=true"
import script from "./cdrBatchPremium.vue?vue&type=script&lang=js"
export * from "./cdrBatchPremium.vue?vue&type=script&lang=js"

import "./cdrBatchPremium.vue?vue&type=style&index=0&id=17ef5e97&scoped=true&lang=css"
import "./cdrBatchPremium.vue?vue&type=style&index=1&id=17ef5e97&lang=css"
script.render = render
script.__scopeId = "data-v-17ef5e97"

export default script